import React from 'react';
import type { CustomContentProps, SnackbarKey } from 'notistack';
import { closeSnackbar } from 'notistack';
import { ToastProviderToastProps } from '../providers/ToastProvider';
import { ToastProps } from '../types/ToastProps';
import { ToastAlert } from './ToastAlert';

// Custom snackbar content component mapped to all variants
type ToastSnackbarProps = CustomContentProps &
  Pick<ToastProviderToastProps, 'title' | 'subtitle' | 'onToastClose'> & {
    id: SnackbarKey;
    apSeverity: ToastProps['severity'];
  };

/**
 * A wrapper around the ToastAlert component that is passed to the SnackbarProvider
 * @param props - ToastSnackbarProps
 * @param ref - React.Ref<HTMLDivElement>
 * @returns React.ReactNode
 */
export const ToastSnackbar = React.forwardRef<HTMLDivElement, ToastSnackbarProps>((props, ref) => {
  const { id, title, subtitle, apSeverity, onToastClose } = props;

  return (
    <ToastAlert
      ref={ref}
      severity={apSeverity}
      title={title}
      onClose={() => {
        closeSnackbar(id);
        onToastClose?.();
      }}
      subtitle={subtitle}
    />
  );
});

ToastSnackbar.displayName = 'ToastSnackbar';
